module.exports = __webpack_public_path__ + "static/media/welcomeImg.d796569a.png";